export default {
  error: null,
  campaign: {},
  order: {
    loading: false,
    campaign: {},
    customer: {
      anonymous: false,
    },
    offers: [],
    quantity: 1,
  },
};
